<ng-template #cellTemplateStage let-row="row" let-columnId="columnId">
  <div class="table-cell">
    @for (item of row.values[columnId]; track item.id) {
      <div class="cell-value" layout-horizontal layout-align-items-center>
        <rt-stage-category-color-indicator
          [stageCategory]="item.category ?? item.id"
          margin-right-small-x
        />
        <span class="stage-cell-value">{{ item.name }}</span>
      </div>
    }
  </div>
</ng-template>

<ng-template #nonClickableCell let-textContent="textContent">
  <div
    class="cell-value"
    [class.empty-duration]="data()?.dataset?.metric?.unitType === 'duration' && textContent === '0'"
  >
    <rt-truncate>
      {{
        data()?.dataset?.metric?.unitType === 'duration' && textContent === '0' ? '-' : textContent
      }}
    </rt-truncate>
  </div>
</ng-template>

<ng-template
  #clickableCell
  let-row="row"
  let-cellIndex="cellIndex"
  let-textContent="textContent"
  let-itemIndex="itemIndex"
>
  <div class="cell-value clickable" (click)="openResource(row.index, itemIndex)">
    <rt-icon name="open-in-new" />
    <rt-truncate>
      {{ textContent }}
    </rt-truncate>
  </div>
</ng-template>

<ng-template #headerCellDefault let-column="col">
  <span [class.line-truncate]="column.index > 0">{{ column.label }}</span>
</ng-template>

<div class="shadow-parent">
  <div
    #scrollContainer
    class="data-table-container overload with-shadow"
    [class.shadow-left]="shadows().left"
    [class.shadow-right]="shadows().right"
  >
    <rt-data-table
      #dataTableComponent
      [columnHeaderTemplate]="headerCellDefault"
      [cellPadding]="false"
      [rows]="dataTableRowsMapped() | rtTablePagination: pagination()"
      [cols]="dataTableColumnsMapped()"
      [cellTemplates]="{
        'stage-category': cellTemplateStage,
        'stage-name': cellTemplateStage,
      }"
      [autoFit]="true"
      [clickable]="false"
      [defaultCellTemplate]="tableCellTemplate"
      (sortChange)="toggleColumnSort($event)"
    />
  </div>
</div>
@if (pagination().pagesCount > 1) {
  <rt-toolbar #toolbarComponent margin-top>
    <rt-toolbar-secondary layout>
      <rt-pagination-counter
        [total]="pagination().total"
        [start]="pagination().start"
        [end]="pagination().end"
        margin-right-small
      />
      <rt-pagination
        [page]="pagination().page"
        [pagesCount]="pagination().pagesCount"
        [prevPageDisabled]="pagination().page === 1"
        [nextPageDisabled]="pagination().page === pagination().pagesCount"
        (pageChange)="changePage($event)"
      />
    </rt-toolbar-secondary>
  </rt-toolbar>
}

<ng-template #tableCellTemplate let-row="row" let-columnId="columnId">
  <div class="table-cell">
    @for (item of row.values[columnId]; track item.id) {
      <ng-container
        [ngTemplateOutlet]="isClickable(item) ? clickableCell : nonClickableCell"
        [ngTemplateOutletContext]="{
          row: row,
          columnId: columnId,
          textContent: item.formatted ?? item.name,
          itemIndex: item.originalIndex,
        }"
      />
    }
  </div>
</ng-template>
